
// Maximum number of recently used locations to store
const MAX_RECENT_LOCATIONS = 5;
const RECENT_LOCATIONS_KEY = 'recentLocations';

export interface StoredLocation {
  description: string;
  timestamp: number;
}

/**
 * Save a location to the recently used locations in localStorage
 */
export const saveRecentLocation = (location: string): void => {
  if (!location.trim()) return;
  
  try {
    // Get existing locations
    const existingLocations = getRecentLocations();
    
    // Check if this location already exists
    const existingIndex = existingLocations.findIndex(
      loc => loc.description.toLowerCase() === location.toLowerCase()
    );
    
    // If it exists, remove it (we'll add it back at the top)
    if (existingIndex !== -1) {
      existingLocations.splice(existingIndex, 1);
    }
    
    // Add the new location at the beginning
    const updatedLocations = [
      { description: location, timestamp: Date.now() },
      ...existingLocations
    ].slice(0, MAX_RECENT_LOCATIONS); // Keep only the most recent ones
    
    localStorage.setItem(RECENT_LOCATIONS_KEY, JSON.stringify(updatedLocations));
  } catch (error) {
    console.error('Error saving recent location:', error);
  }
};

/**
 * Get recently used locations from localStorage
 */
export const getRecentLocations = (): StoredLocation[] => {
  try {
    const storedLocations = localStorage.getItem(RECENT_LOCATIONS_KEY);
    if (!storedLocations) return [];
    
    const parsedLocations = JSON.parse(storedLocations) as StoredLocation[];
    return parsedLocations.slice(0, MAX_RECENT_LOCATIONS);
  } catch (error) {
    console.error('Error retrieving recent locations:', error);
    return [];
  }
};
